'use strict';

module.exports = /\(([-+]\d{2,4}|\w{3,5})\)$/;


// WEBPACK FOOTER //
// ./~/sugar-date/date/var/TIMEZONE_ABBREVIATION_REG.js